import { mapState } from 'vuex'

export default {
  data () {
    return {
      tabLinks: []
    }
  },
  computed: {
    ...mapState([ 'Auth' ]),
    permissionsManagement () {
      return this.Auth.userData?.permissions
    },
    availableTabLink () {
      return this.tabLinks.filter(tab => !tab.disabled)
    }
  },
  created () {
    this.createMenuTabManagement()
  },
  watch: {
    permissionsManagement: {
      handler () {
        this.createMenuTabManagement()
      }
    }
  },
  methods: {
    createMenuTabManagement () {
      this.tabLinks = [
        {
          location: { name: 'management.index' },
          text: this.$t('management.tabs:link.1')
        },
        {
          location: { name: 'management.user.profiles' },
          text: this.$t('management.tabs:link.2'),
          disabled: !this.getContextPermission('profiles')
        },
        {
          location: { name: 'management.survey' },
          text: this.$t('management.tabs:link.4'),
          disabled: !this.getContextPermission('surveys')
        },
        {
          location: { name: 'management.certificates' },
          text: this.$t('management.tabs:link.5'),
          disabled: !this.getContextPermission('certificates')
        },
        {
          location: {
            name: 'management.banners',
            params: { activeTab: 'tools' }
          },
          text: this.$t('management.tabs:link.6'),
          disabled: !this.getContextPermission('banners')
        },
        {
          location: { name: 'management.partners' },
          text: this.$t('management.tabs:link.partners'),
          disabled: !this.getContextPermission('partners')
        },
        {
          location: { name: 'management.gamification' },
          text: this.$t('management.tabs:link.7'),
          disabled: !this.getContextPermission('gamification')
        },
        {
          location: { name: 'management.settings' },
          text: this.$t('management.tabs:link.settings'),
          disabled: !this.getContextPermission('configurations')
        }
      ]
    }
  }
}
